import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 整箱Addon运价维护-列表查询
export function queryPriceFclAddon(data) {
  return request({
    url: URL.price.priceFclAddon.queryPriceFclAddon,
    method: 'post',
    data
  })
}
// 整箱Addon运价维护-保存
export function savePriceFclAddon(data) {
  return request({
    url: URL.price.priceFclAddon.savePriceFclAddon,
    method: 'post',
    data
  })
}
// 整箱Addon运价维护-批量删除
export function deletePriceFclAddons(data) {
  return request({
    url: URL.price.priceFclAddon.deletePriceFclAddons,
    method: 'post',
    data
  })
}
// 整箱Addon运价维护-批量审核
export function approvePriceFclAddons(data, params) {
  return request({
    url: URL.price.priceFclAddon.approvePriceFclAddons,
    method: 'post',
    data,
    params
  })
}
